<template>
<header class="header-default pa-3">

    <!-- <v-toolbar-side-icon @click.stop="menu" class="hidden-lg-and-up"></v-toolbar-side-icon> -->
    <v-btn flat icon color="primary" :to="{name:'Busca'}" v-if="this.$route.name !== 'Busca'">
        <v-icon>search</v-icon>
    </v-btn>

    <v-btn dark flat icon color="pink" @click="goBack()" v-if="this.$route.name === 'Busca'">
        <v-icon>close</v-icon>
    </v-btn>

    <!-- <v-menu
      :close-on-content-click="false"
      :nudge-width="200"
      v-model="menuNotifications"
      offset-y
      class="pull-right"
    >
      <v-btn slot="activator" flat icon color="primary"><v-icon v-if="menuNotifications">notifications</v-icon><v-icon v-else>notifications_none</v-icon></v-btn>

      <v-card class="menuNotifications">
        <v-list two-line v-if="items.length > 0">
          <template v-for="(item, index) in items">
            <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <v-list-tile v-else :key="item.title" avatar to="/">
              <v-list-tile-avatar>
                <img :src="item.img">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
        <v-list v-else>
          <v-subheader>Oops, nenhuma nova notificação.</v-subheader>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-menu> -->
</header>
</template>

<script>
import bus from '@/utils/bus'

export default {
	name: 'headerDefault',
	props: {
		title: null,
		showBackButton: true,
		props: ['backArrow']
	},
	components: {
		loading: true,
	},
	data() {
		return {
			// drawer: true,
			menuNotifications: false,
			backArrow: 0,
			items: [
				//{ header: 'Today' },
				/* { img: require('../assets/img/background.png'), title: 'Nome da nova edição', subtitle: "Leia agora a magna pars studiorum, prodita quaerimus" },
        { divider: true, inset: true },
        { img: require('../assets/img/background.png'), title: 'Summer BBQ ', subtitle: "dasdasda" },
        { divider: true, inset: true },
        { img: require('../assets/img/background.png'), title: 'Oui oui', subtitle: "dassdadas" } */
			]
		}
	},
	created() {

	},
	mounted() {
		bus.$emit('loading', false)
	},
	methods: {
		menu() {
			bus.$emit('menu', true)
		},

		goBack() {
			if (window.history.length > 2) {
				this.$router.go(-1)
			} else {
				this.$router.push('/')
			}
			// window.history.length > 0 ? this.$router.go(-1) : this.$router.push('/')
		}
	}
}
</script>

<style lang="scss">
@import "../assets/css/_variables";
// .header-default{

// }
</style>
